var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIktOstLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ikt-ost-logo_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ikt-ost-logo_svg__b{fill:#13a137}.ikt-ost-logo_svg__c{fill:#de0713}.ikt-ost-logo_svg__d{fill:#0064ab}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ikt-ost-logo_svg__c",
    d: "M106.76,111.78c-2.78.45-3.88,8.17.67,8.81,3.12.43,13.89.47,16.79-.22,2.63-.62,3.84-2.38,3.79-5.08l-.17-104.37c-.55-1.93-2.02-3.27-4.02-3.58s-16.3-.36-17.59.07c-2.56.86-2.3,8.76.53,8.76h10.45v95.61c-3.21.37-7.38-.5-10.45,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ikt-ost-logo_svg__b",
    d: "M102.53,115.5c-.91,1.34-11.11,1.69-10.81-2.65L54.59,11.3c-.28-2.96,10.12-3.25,10.79-.01,10.72,32.89,25.55,65.41,35.97,98.27.42,1.33,1.9,4.88,1.18,5.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ikt-ost-logo_svg__b",
    d: "M41.69,50.54c26.09-2.59,36.21,20.1,29.22,42.52-7.35,23.57-43.87,25.24-51.74,2.43-6.49-18.8.25-42.74,22.52-44.95ZM41.67,59.39c-20.96,3.06-18.9,51.19,8.89,42.45,16.92-5.32,17.06-46.24-8.89-42.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ikt-ost-logo_svg__d",
    d: "M21.24,111.78c2.78.45,3.88,8.17-.67,8.81-3.12.43-13.89.47-16.79-.22C1.16,119.75-.05,117.99,0,115.29L.17,10.92c.55-1.93,2.02-3.27,4.02-3.58s16.3-.36,17.59.07c2.56.86,2.3,8.76-.53,8.76h-10.45v95.61c3.21.37,7.38-.5,10.45,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIktOstLogo);
export default __webpack_public_path__ + "static/media/ikt-ost-logo.166a9ed7ac26d9aa3e9d1bd673feb511.svg";
export { ForwardRef as ReactComponent };